import type { PlaceData } from './types';

export function createEmptyPlace(): PlaceData {
	return {
		weight: '',
		volume: '',
		long: '',
		width: '',
		height: '',
		declaredValue: '',
		quantity: '',
		crate: false,
		pallet: false,
		stretchFilm: false,
	};
}

export function parseVal(val: string | number | null | undefined): number {
	if (val === null || val === undefined || val === '') {
		return 0;
	}

	return parseFloat(String(val).replace(',', '.')) || 0;
}

export function formatNumber(
	num: number,
	decimals = 2,
	decSeparator = '.',
	thouSeparator = ' ',
): string {
	return num
		.toFixed(decimals)
		.replace('.', decSeparator)
		.replace(/\B(?=(\d{3})+(?!\d))/g, thouSeparator);
}

export function validateMaxDimensions(l: number, w: number, h: number): boolean {
	if (l === 0 && w === 0 && h === 0) {
		return true;
	}

	const sides = [l, w, h].sort((a, b) => a - b);
	return !(sides[0] > 2.5 || sides[1] > 2.5 || sides[2] > 13.0);
}

export function sanitizeNumeric(value: string | number | null | undefined): string {
	return String(value ?? '').replace(/[^\d.,]/gi, '');
}
